"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Order model module.
 * @module model/Order
 * @version 1.0.44
 */
var Order = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Order</code>.
   * Ein Bestellposten
   * @alias module:model/Order
   * @param name {String} Name des Bestellpostens bzw 3-Stelliger ISO Code (LANG_BEZ, EM_BEZ bzw SO_BEZ)
   * @param preis {Number} Kundenpreis (EM_KPREIS bzw SO_KKURS)
   * @param versandkosten {Number} Betrag der Versandkosten (DVKUBETR)
   * @param endsumme {Number} Gesamtpreis der Bestellung (GESAMT)
   * @param kennziffer {Number} Id des Postens (KENNZ)
   */
  function Order(name, preis, versandkosten, endsumme, kennziffer) {
    _classCallCheck(this, Order);
    Order.initialize(this, name, preis, versandkosten, endsumme, kennziffer);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Order, null, [{
    key: "initialize",
    value: function initialize(obj, name, preis, versandkosten, endsumme, kennziffer) {
      obj['name'] = name;
      obj['preis'] = preis;
      obj['versandkosten'] = versandkosten;
      obj['endsumme'] = endsumme;
      obj['kennziffer'] = kennziffer;
    }

    /**
     * Constructs a <code>Order</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Order} obj Optional instance to populate.
     * @return {module:model/Order} The populated <code>Order</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Order();
        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
        }
        if (data.hasOwnProperty('image')) {
          obj['image'] = _ApiClient.default.convertToType(data['image'], 'String');
        }
        if (data.hasOwnProperty('preis')) {
          obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
        }
        if (data.hasOwnProperty('mwstProzent')) {
          obj['mwstProzent'] = _ApiClient.default.convertToType(data['mwstProzent'], 'Number');
        }
        if (data.hasOwnProperty('anzahl')) {
          obj['anzahl'] = _ApiClient.default.convertToType(data['anzahl'], 'Number');
        }
        if (data.hasOwnProperty('mwstBetrag')) {
          obj['mwstBetrag'] = _ApiClient.default.convertToType(data['mwstBetrag'], 'Number');
        }
        if (data.hasOwnProperty('netto')) {
          obj['netto'] = _ApiClient.default.convertToType(data['netto'], 'Number');
        }
        if (data.hasOwnProperty('brutto')) {
          obj['brutto'] = _ApiClient.default.convertToType(data['brutto'], 'Number');
        }
        if (data.hasOwnProperty('displaybrutto')) {
          obj['displaybrutto'] = _ApiClient.default.convertToType(data['displaybrutto'], 'String');
        }
        if (data.hasOwnProperty('displaynetto')) {
          obj['displaynetto'] = _ApiClient.default.convertToType(data['displaynetto'], 'String');
        }
        if (data.hasOwnProperty('displaymwstBetrag')) {
          obj['displaymwstBetrag'] = _ApiClient.default.convertToType(data['displaymwstBetrag'], 'String');
        }
        if (data.hasOwnProperty('versandkosten')) {
          obj['versandkosten'] = _ApiClient.default.convertToType(data['versandkosten'], 'Number');
        }
        if (data.hasOwnProperty('endsumme')) {
          obj['endsumme'] = _ApiClient.default.convertToType(data['endsumme'], 'Number');
        }
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'Number');
        }
        if (data.hasOwnProperty('betrag')) {
          obj['betrag'] = _ApiClient.default.convertToType(data['betrag'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Order</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Order</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Order.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
        throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
      }
      // ensure the json data is a string
      if (data['image'] && !(typeof data['image'] === 'string' || data['image'] instanceof String)) {
        throw new Error("Expected the field `image` to be a primitive type in the JSON string but got " + data['image']);
      }
      // ensure the json data is a string
      if (data['displaybrutto'] && !(typeof data['displaybrutto'] === 'string' || data['displaybrutto'] instanceof String)) {
        throw new Error("Expected the field `displaybrutto` to be a primitive type in the JSON string but got " + data['displaybrutto']);
      }
      // ensure the json data is a string
      if (data['displaynetto'] && !(typeof data['displaynetto'] === 'string' || data['displaynetto'] instanceof String)) {
        throw new Error("Expected the field `displaynetto` to be a primitive type in the JSON string but got " + data['displaynetto']);
      }
      // ensure the json data is a string
      if (data['displaymwstBetrag'] && !(typeof data['displaymwstBetrag'] === 'string' || data['displaymwstBetrag'] instanceof String)) {
        throw new Error("Expected the field `displaymwstBetrag` to be a primitive type in the JSON string but got " + data['displaymwstBetrag']);
      }
      return true;
    }
  }]);
}();
Order.RequiredProperties = ["name", "preis", "versandkosten", "endsumme", "kennziffer"];

/**
 * Name des Bestellpostens bzw 3-Stelliger ISO Code (LANG_BEZ, EM_BEZ bzw SO_BEZ)
 * @member {String} name
 */
Order.prototype['name'] = undefined;

/**
 * Bild zum Anzegen des Postens
 * @member {String} image
 */
Order.prototype['image'] = undefined;

/**
 * Kundenpreis (EM_KPREIS bzw SO_KKURS)
 * @member {Number} preis
 */
Order.prototype['preis'] = undefined;

/**
 * Prozentsatz der Mehrwertsteuer (EM_MWSTP)
 * @member {Number} mwstProzent
 */
Order.prototype['mwstProzent'] = undefined;

/**
 * Menge des Bestellpostens bei Edelmetallen (EM_ANZAHL)
 * @member {Number} anzahl
 */
Order.prototype['anzahl'] = undefined;

/**
 * Betrag der Mehrwertsteuer (EM_MWST)
 * @member {Number} mwstBetrag
 */
Order.prototype['mwstBetrag'] = undefined;

/**
 * Netto Betrag (EM_NETTO)
 * @member {Number} netto
 */
Order.prototype['netto'] = undefined;

/**
 * Brutto Kosten
 * @member {Number} brutto
 */
Order.prototype['brutto'] = undefined;

/**
 * Brutto Kosten als String
 * @member {String} displaybrutto
 */
Order.prototype['displaybrutto'] = undefined;

/**
 * Netto Betrag als String
 * @member {String} displaynetto
 */
Order.prototype['displaynetto'] = undefined;

/**
 * Mehrwertsteuer als String
 * @member {String} displaymwstBetrag
 */
Order.prototype['displaymwstBetrag'] = undefined;

/**
 * Betrag der Versandkosten (DVKUBETR)
 * @member {Number} versandkosten
 */
Order.prototype['versandkosten'] = undefined;

/**
 * Gesamtpreis der Bestellung (GESAMT)
 * @member {Number} endsumme
 */
Order.prototype['endsumme'] = undefined;

/**
 * Id des Postens (KENNZ)
 * @member {Number} kennziffer
 */
Order.prototype['kennziffer'] = undefined;

/**
 * Sorten Betrag (SO_BETR)
 * @member {Number} betrag
 */
Order.prototype['betrag'] = undefined;
var _default = exports.default = Order;